import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Container, useMediaQuery, useTheme, Drawer } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';
var Layout = function (_a) {
    var children = _a.children, title = _a.title;
    var _b = useState(false), sidebarOpen = _b[0], setSidebarOpen = _b[1];
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    var sidebarWidth = 280;
    var handleSidebarToggle = function () {
        setSidebarOpen(!sidebarOpen);
    };
    return (_jsxs(Box, { className: "min-h-screen bg-gray-50 flex", children: [!isMobile && (_jsx(Drawer, { variant: "permanent", sx: {
                    width: sidebarWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: sidebarWidth,
                        boxSizing: 'border-box',
                        borderRight: '1px solid',
                        borderColor: 'divider',
                        boxShadow: 'none',
                    },
                }, children: _jsx(Sidebar, { open: true, onClose: function () { }, isPersistent: true }) })), isMobile && (_jsx(Sidebar, { open: sidebarOpen, onClose: function () { return setSidebarOpen(false); }, isPersistent: false })), _jsxs(Box, { className: "flex-1 flex flex-col", sx: { width: isMobile ? '100%' : "calc(100% - ".concat(sidebarWidth, "px)") }, children: [_jsx(Header, { title: title, onMenuClick: handleSidebarToggle, showMenuButton: isMobile }), _jsx(Box, { component: "main", className: "flex-1 overflow-auto", children: _jsx(Container, { maxWidth: "xl", className: "py-6", children: children }) })] })] }));
};
export default Layout;
